
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.md?watch=parent';
    export const demoIndex = {
  ids: ["pinmap-demo-default","pinmap-demo-marker","pinmap-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__PinMap" */'/home/runner/work/GPT-Vis/GPT-Vis/src/PinMap/index.md?type=demo')
};